export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100">
            <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-600"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 font-body">
            欢迎影视创作者、版权方与合作伙伴联系我们。投稿优质影片资源、商务合作洽谈或反馈意见，豆花视频期待与你携手为观众带来更丰富的免费在线观看体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#faq"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#faq');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold font-label rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-question-answer-line"></i>
              查看常见问题
            </a>
            <span className="text-sm text-foreground-500 font-body whitespace-nowrap">
              或发送邮件至 contact@douhua.video
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}